import { ProgramsLayout } from '@components/buzzkuri/shared/layouts/Programs'
import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import { InitProgramNavList } from '@context/ProgramNavList/InitProgramNavList'
import { ProgramsPathsContext } from '@context/ProgramsPaths/Context'
import { ProgramsPageRes } from '@type/buzzkuri/programs'
import { useContext, useEffect } from 'react'
import { CategoryNavList } from './CategoryNavList'
import { FindTrainingProgramSection } from './FindTrainingProgramSection'
import { NewArrivalsColumn } from './NewArrivalsColumn'

export const ProgramsPage = ({
  pageContent,
  business,
}: ProgramsPageRes): JSX.Element => {
  const { init } = useContext(ProgramsPathsContext)
  useEffect(() => init, [init])

  const { totalProgramCount, programCategories } = pageContent
  InitProgramNavList({ totalProgramCount, programCategories })

  return (
    <ProgramsLayout {...{ business }}>
      <>
        <div className="mt-[5vw] lg:mt-[3.5vw] w-[87.2vw] lg:w-[62.6vw] text-left">
          <BuzzkuriBreadcrumb />
        </div>

        <div className="mt-[4.8vw] lg:mt-[1.4vw]">
          <FindTrainingProgramSection
            popularPrograms={pageContent.popularPrograms}
            newPrograms={pageContent.newPrograms}
            objectives={pageContent.objectives}
            recommendTags={pageContent.recommendTags}
          />
        </div>

        <div className="mt-[10vw] lg:mt-[4.7vw]">
          <NewArrivalsColumn feedItems={pageContent.feedItems} />
        </div>
        <div className="mt-[16.1vw] lg:mt-[6vw]">
          <CategoryNavList />
        </div>
      </>
    </ProgramsLayout>
  )
}
